import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionVoiceAndToneCompetent = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"type": "page",
			"properties": {
				"title": [
					[
						"Пишем компетентно"
					]
				]
			},
			"content": [
				"eee82228-305a-43ad-b48e-7daf90a49a04",
				"ece2e1d6-5f63-40ac-a7ca-2e339f7daed5",
				"857ada0f-87e8-48bf-8783-03d3a966b53f",
				"8a223809-eb3d-4cc2-9bfb-5769a65068b2",
				"58e7addc-e423-44c7-9890-8fad55f785a4",
				"076b55b1-ead8-4e3c-b0d1-01312dffc238",
				"dd6edbae-0fe1-4b08-a5ab-9a9f710fc299",
				"804cb27a-cc0e-4218-bd71-324ff71088d3",
				"54ead852-d680-4f5d-a4bd-9cd477e37a18",
				"e7d17121-7c2e-48b1-8ca2-1ed2f190743b",
				"28403d0e-5b0b-44b1-b507-466876d0eb5a",
				"a935ddc9-9413-4605-b051-7fdbaade3e32",
				"8eac0646-5474-4f48-8410-d689103fbdc4",
				"c2c989c9-c821-40d7-9644-d2b40dfc3268",
				"736316b4-d3d6-4cd5-acc6-fcce5d4ec5c2",
				"b8bf1265-1fa2-4d0c-b082-53a6776edeb6",
				"da57281d-ebed-4ba0-bf27-82bde05efe18",
				"d52dfc54-37a3-4140-94d2-3753fbe9157b",
				"0f5bbefe-3e44-41cd-b271-a87640eb5c74",
				"dfaeea19-818f-4654-80cb-fb2435040c1a",
				"3e9c3fd0-2be5-4e1a-9815-8cd7182d4db5",
				"b7a16b93-0fbc-48ba-8c2f-6f7aad5f614e",
				"c6060f49-3d6e-4446-b480-ae5ce6df041f",
				"1f11a8cb-d4bb-49bf-b0b9-5d88d738e60a",
				"bf7ca23c-7587-49e1-8704-70f6669b6389",
				"09ccf3d9-7099-4467-8ced-2317145f21e0",
				"66956d03-0154-4ed6-b3f3-38abcfc10c7c",
				"b8778fa0-dd31-4c67-9cca-4d0d6f7c66e6",
				"e47cbace-dff6-4960-aff8-4e6cc7af36d5",
				"cbe2d890-0aa6-462d-b496-7c7b196dca7e",
				"a669ab06-e5b6-4d07-9694-71fee7bf219f",
				"1cdb7ad9-5192-4824-bcd4-17313d2f0dfb",
				"a5bf4e2c-8bbf-4211-85f5-26699d2a1cd8",
				"43cc6f0b-7d14-45a8-82fc-ac79900e8987",
				"06d8dc2d-fb96-4e6c-993e-181b8509411b",
				"cd47ebe3-d051-4b2b-859f-61aff4b4414d",
				"1d65d6a0-7904-486b-bedc-da67846e143c",
				"05a86091-0c1d-4d92-a5db-75eebbb91cc8",
				"79cf2288-4b7a-4722-ba79-f26feb8cf82e",
				"2be11ce6-12a8-425f-8561-449969e0083d",
				"33732f50-1024-43d4-93ac-2198de21e3a3",
				"f3ee82ef-9d7f-4f71-b041-2cf61242b628",
				"8fb50032-b07a-444e-90ac-98b3cba1fd3a",
				"18fd90ca-6ab0-40db-98e9-51b0d9f56c2a",
				"66f73984-1968-4cef-836a-a10614fd3ae3",
				"d2be349e-d08d-4afa-a307-d0296ba6afe1",
				"9672f76a-8d90-4ff8-88f6-8f6707fc9ed0",
				"22505215-a6da-45d1-b337-f4f85e73d3f3"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eee82228-305a-43ad-b48e-7daf90a49a04",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/voice_and_tone/competent\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "59965235-a5bf-47ab-a373-a550ce0256e7",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ece2e1d6-5f63-40ac-a7ca-2e339f7daed5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наши пользователи доверяют нам своё время и внимание.\nНам важно беречь это и давать только то, что принесёт пользу, сэкономит ресурс, создаст безопасную среду и поддержит тогда, когда это особенно нужно."
					]
				]
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "857ada0f-87e8-48bf-8783-03d3a966b53f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Поэтому мы:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "84e0830e-df08-4ac7-a69c-5f7ad9c33b03",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a223809-eb3d-4cc2-9bfb-5769a65068b2",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"говорим честно и открыто"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dee4f656-5282-4a5f-a629-aa733401d72b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "58e7addc-e423-44c7-9890-8fad55f785a4",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"делимся опытом и возможностями"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7351eacd-c7a8-40c8-a324-69c60d259f4d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "076b55b1-ead8-4e3c-b0d1-01312dffc238",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"поддерживаем, мотивируем и всегда стоим рядом"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e7082ec1-97bf-4a58-9133-482b61929c17",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dd6edbae-0fe1-4b08-a5ab-9a9f710fc299",
			"type": "header",
			"properties": {
				"title": [
					[
						"Честность и простота"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d5baecb8-3a58-4203-a5ab-246c5c40b111",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "804cb27a-cc0e-4218-bd71-324ff71088d3",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Говорим конкретно и без воды  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aeccdb4d-cea6-4a70-b241-8a65a8908ce2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "54ead852-d680-4f5d-a4bd-9cd477e37a18",
			"type": "text",
			"properties": {
				"title": [
					[
						"«Очень», «самые», «абсолютно» — слова-усилители, которые делают текст слабее.\nУ фразы появится смысл и фактура, если в ней будут живые примеры из жизни, понятные цифры, факты. Если раскрыть смысл с помощью примеров не можем, стоит подумать над тем, как переформулировать текст или вовсе промолчать. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "58db8098-bd78-4032-b9a4-c36593b01ca1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e7d17121-7c2e-48b1-8ca2-1ed2f190743b",
			"type": "column_list",
			"content": [
				"29ab1c0e-2b2e-4046-b03c-c7c393bf5e64",
				"6d5a97b2-788f-44e8-a3f2-dd36280377d9"
			],
			"format": {
				"copied_from_pointer": {
					"id": "c92a810a-12c2-44d2-a94c-6910ff84de96",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "28403d0e-5b0b-44b1-b507-466876d0eb5a",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не обещаем больше, чем есть "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9d3b9fa4-2dd6-4204-9c80-b95db897ccfb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a935ddc9-9413-4605-b051-7fdbaade3e32",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иногда маркетинговый текст предполагает яркий заголовок, который должен «зацепить» человека, но стоит сохранять дистанцию и спокойно рассказывать о реальных преимуществах, а не вымышленных. Не врём и не преувеличиваем. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6a466f6f-d4a1-42f7-8eda-2c61f9071ba0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8eac0646-5474-4f48-8410-d689103fbdc4",
			"type": "column_list",
			"content": [
				"28f27980-0894-4e28-a480-3fc7f1ff4531",
				"68791819-f23b-4c95-ad94-50c1f6022d24"
			],
			"format": {
				"copied_from_pointer": {
					"id": "2f6dcfdc-6d77-40ca-80b7-8af3a41a49ae",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c2c989c9-c821-40d7-9644-d2b40dfc3268",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не даём оценок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "194da5b7-8a74-499f-ab26-a113b5e74472",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "736316b4-d3d6-4cd5-acc6-fcce5d4ec5c2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наша задача — честно рассказать о продукте, не утаивать его особенности, заранее предупредить человека, что будет, если… Не склоняем к покупкам, не давим эмоционально, не манипулируем, не додумываем. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "31ff5d7e-f587-4664-8cbb-83bc8f164726",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b8bf1265-1fa2-4d0c-b082-53a6776edeb6",
			"type": "column_list",
			"content": [
				"facf4830-8fd0-46c6-a82d-7c118659af41",
				"4b7ff809-e47a-4dcb-af98-0668a380fde1"
			],
			"format": {
				"copied_from_pointer": {
					"id": "aa69ba4b-ac92-4f01-92a8-2c22480192c7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "da57281d-ebed-4ba0-bf27-82bde05efe18",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Учитываем контекст и подтекст "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d7f8704b-5d8f-4b61-81d5-d7d14d39cfca",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d52dfc54-37a3-4140-94d2-3753fbe9157b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Внимательно посмотрите на фразу. «Переоденьтесь» в пользователя, представьте, как может среагировать молодой и пожилой человек, мужчина и женщина, одинокий и семейный. Задайте тексту неудобные вопросы. Подумайте о контексте. Помните\nо границах. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6f9ae0bd-e27a-4ca3-9fe8-095513fa0687",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0f5bbefe-3e44-41cd-b271-a87640eb5c74",
			"type": "column_list",
			"content": [
				"ecc22554-4640-43df-a586-013f3b522932",
				"47141466-7913-45e8-887e-788d58e834e5"
			],
			"format": {
				"copied_from_pointer": {
					"id": "5f9487f4-722a-4b05-8530-09ff8071c4dc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dfaeea19-818f-4654-80cb-fb2435040c1a",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Говорим однозначно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f2f169cf-bd43-4b6d-b1d5-5b6d26138091",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3e9c3fd0-2be5-4e1a-9815-8cd7182d4db5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Одно понятие — одно слово, которое обозначает это понятие. Не путаем пользователя разными названиями одного и того же. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2434013a-5108-4a99-8371-645fe89d6bbc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7a16b93-0fbc-48ba-8c2f-6f7aad5f614e",
			"type": "column_list",
			"content": [
				"b8897ff1-6c2a-4d95-b742-f44f34eb65d6",
				"c578ec58-9927-4729-8d7b-34cc552b5ca6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "0dd1cfbd-02a4-4681-9d96-eca19eef4733",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c6060f49-3d6e-4446-b480-ae5ce6df041f",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Поддерживаем и проявляем эмпатию "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "962a420b-4812-481a-9dfa-ee07be3c18ed",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1f11a8cb-d4bb-49bf-b0b9-5d88d738e60a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы сохраняем уважительные отношения на равных, без гиперсильных эмоций и додумываний. При этом заботливы и эмпатичны. Мы — классный товарищ: уверены в своих силах и компетенциях, держим обещания, не обманываем и готовы помогать. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "596088fe-83f9-4415-a8ec-f60d03a1d5e0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bf7ca23c-7587-49e1-8704-70f6669b6389",
			"type": "column_list",
			"content": [
				"67212201-2bdb-4a09-ab0a-900f703e6a1a",
				"614e73cb-30b2-4bf9-bbd2-f493d5c8283a"
			],
			"format": {
				"copied_from_pointer": {
					"id": "d9c111d2-8da7-4eb1-b61f-d64b576e9aa0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "09ccf3d9-7099-4467-8ced-2317145f21e0",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не используем бессмысленный фактоид"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2f9b69d0-aebd-4dc1-a82e-1b68ffb5f35b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "66956d03-0154-4ed6-b3f3-38abcfc10c7c",
			"type": "text",
			"properties": {
				"title": [
					[
						"«У нас 50 моделей машинного обучения, 100 шаблонов, а ещё 50 офисов».\nЭти численные значения не приносят человеку никакой пользы. Числа относительны и оторваны от его опыта. Их не с чем сравнить, не на что опереться.\n\nЛюбое число стоит «приземлить» на опыт человека, дать сравнение или привести пример. Если это просто хвастовство — не стоит говорить об этом вовсе. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "60803393-58c8-4617-946b-520385c9e10c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b8778fa0-dd31-4c67-9cca-4d0d6f7c66e6",
			"type": "column_list",
			"content": [
				"88921780-b3c5-4348-b972-a2157488405c",
				"6444cafc-114d-4930-86f0-9360e778fc8a"
			],
			"format": {
				"copied_from_pointer": {
					"id": "76490918-d9c6-449e-a44d-7823e1792dc1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e47cbace-dff6-4960-aff8-4e6cc7af36d5",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Шутим уместно и по-доброму "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eafa4bd4-dc17-4cc5-a2b8-632f0db3f512",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cbe2d890-0aa6-462d-b496-7c7b196dca7e",
			"type": "text",
			"properties": {
				"title": [
					[
						"В коммуникации от лица команды мы можем шутить, но делаем это бережно: не переступаем границы, учитываем контекст сценария. Бородатые, пошлые, избитые шутки — не про нас. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "718acb66-4202-4046-87b4-fb95510653fc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a669ab06-e5b6-4d07-9694-71fee7bf219f",
			"type": "column_list",
			"content": [
				"e9e487b4-27ef-4bfb-9d80-db44605b0f08",
				"3a787547-210f-451c-b5d4-b7934b46d0e6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "cc4d85e9-e3bf-4245-ae44-8b26da641466",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1cdb7ad9-5192-4824-bcd4-17313d2f0dfb",
			"type": "header",
			"properties": {
				"title": [
					[
						"Взаимоуважение и равноправие "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "084d09c1-9fcd-4636-b2f0-b1df1a94bdb0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a5bf4e2c-8bbf-4211-85f5-26699d2a1cd8",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Сохраняем достоинство "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2076d379-9049-4f44-9d87-63dc3b07bc58",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "43cc6f0b-7d14-45a8-82fc-ac79900e8987",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы не сравниваем себя с конкурентами, не приводим в примеры кейсы, где другие компании выглядят не лучшим образом. Мы гордимся своими успехами и с радостью ими делимся, но на первом месте — всегда человек и то, в чём польза для него от наших успехов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "caad0616-bd2d-4903-ae46-99527a96bff7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "06d8dc2d-fb96-4e6c-993e-181b8509411b",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Обязательно проверяем все факты. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8ae44a36-583c-49d5-937c-28a42e613f6a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cd47ebe3-d051-4b2b-859f-61aff4b4414d",
			"type": "column_list",
			"content": [
				"2b4033ee-909f-4af2-9137-46426b2b197b",
				"36519d60-51a9-46e7-970e-370afc1922f5"
			],
			"format": {
				"copied_from_pointer": {
					"id": "c00ede73-730b-4caf-bd74-8e24ba29ad1c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1d65d6a0-7904-486b-bedc-da67846e143c",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Говорим гендерно-нейтрально "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "01a6a16e-f27c-4c78-a941-1bf1dbfae7da",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "05a86091-0c1d-4d92-a5db-75eebbb91cc8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наши продукты ориентированы на широкую аудиторию — и мужчин, и женщин, поэтому стараемся уходить от любой привязки к гендеру. Это делает коммуникацию равной для всех участников. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1495de7b-e28c-4781-aa22-a88b1be249db",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "79cf2288-4b7a-4722-ba79-f26feb8cf82e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем только устоявшиеся феминитивы: студентка, учительница. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "257c2324-20df-460a-b0b2-0d3083489def",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2be11ce6-12a8-425f-8561-449969e0083d",
			"type": "column_list",
			"content": [
				"21c26d22-f1ae-42ea-8ce9-61a314b2ab96",
				"0eeca7ec-4dd2-4daa-9087-3398d0bb4116"
			],
			"format": {
				"copied_from_pointer": {
					"id": "8e171399-cee1-4729-8698-f0779ba9744e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "33732f50-1024-43d4-93ac-2198de21e3a3",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не кричим — капслок, восклицания и вопросы "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "380e7a98-2f0a-40f7-9461-2311ec55817a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f3ee82ef-9d7f-4f71-b041-2cf61242b628",
			"type": "text",
			"properties": {
				"title": [
					[
						"Капслок и восклицательный знак делают текст «крикливым» и неуместно-восторженным. Мы не используем капслок, кроме случаев, когда слово или фраза — название продукта."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "34dc14ce-6c1e-44f9-91c9-2a909a3f5753",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8fb50032-b07a-444e-90ac-98b3cba1fd3a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Не используем восклицания, кроме случаев, где это контекстно уместно. Не задаём лишних вопросов — стараемся на них отвечать. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b9899444-ba78-40dc-a0af-a351f7d2c7f5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "18fd90ca-6ab0-40db-98e9-51b0d9f56c2a",
			"type": "column_list",
			"content": [
				"c5c14be9-ab52-4602-bbe3-3b5c83048abe",
				"baf864ed-9a97-428a-bb83-47f05f285288"
			],
			"format": {
				"copied_from_pointer": {
					"id": "c7342bb3-3764-480e-bb7e-d3087170c842",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "66f73984-1968-4cef-836a-a10614fd3ae3",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Пишем грамотно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "33b5d75f-d8fa-430e-8549-21f6905d4bd2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d2be349e-d08d-4afa-a307-d0296ba6afe1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Пишем без ошибок, чтобы в нас не сомневались даже в мелочах. Покажите любой текст второму человеку — так уверенности в том, что всё окей, будет больше. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bb9d006a-55ae-42bf-b711-3bf524b5c779",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9672f76a-8d90-4ff8-88f6-8f6707fc9ed0",
			"type": "column_list",
			"content": [
				"8ce6be93-2bb3-460b-8b3f-f8363256df49",
				"db5e18c5-bbda-441b-8ccd-ed4353f1f908"
			],
			"format": {
				"copied_from_pointer": {
					"id": "53fa5611-4724-40be-a263-ed35957d4060",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "22505215-a6da-45d1-b337-f4f85e73d3f3",
			"type": "text",
			"parent_id": "cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "29ab1c0e-2b2e-4046-b03c-c7c393bf5e64",
			"type": "column",
			"content": [
				"d904ebc7-5e20-4275-b7e9-9bf3af66be99",
				"61bd3c80-03fe-4b41-8e96-ee54e9823a0f"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "39d7beb0-bb4a-41e6-9b37-d630876420cd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e7d17121-7c2e-48b1-8ca2-1ed2f190743b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6d5a97b2-788f-44e8-a3f2-dd36280377d9",
			"type": "column",
			"content": [
				"37eb6d0f-b0c5-4895-a303-3e2277e4c623",
				"f691f318-7c2d-4130-9956-43474dd4dfbd"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "b26cb2b5-adf7-40b1-a9a6-b751163aeaa2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e7d17121-7c2e-48b1-8ca2-1ed2f190743b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d904ebc7-5e20-4275-b7e9-9bf3af66be99",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7cb179f3-97b0-4694-9a1a-0c427fe82021/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7cb179f3-97b0-4694-9a1a-0c427fe82021/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "29ab1c0e-2b2e-4046-b03c-c7c393bf5e64",
			"parent_table": "block",
			"file_ids": [
				"7cb179f3-97b0-4694-9a1a-0c427fe82021"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d904ebc7-5e20-4275-b7e9-9bf3af66be99.png"
		},
		{
			"id": "61bd3c80-03fe-4b41-8e96-ee54e9823a0f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Заботимся о вашей безопасности \n\nОблако за 1 ₽ вместо 299 ₽ \nна 3 месяца "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "4b6353fc-4af6-4cdc-a02a-07d8a08ff317",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "29ab1c0e-2b2e-4046-b03c-c7c393bf5e64",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "37eb6d0f-b0c5-4895-a303-3e2277e4c623",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0b425e8a-75e0-4665-bd26-0a170fbfcbc9/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0b425e8a-75e0-4665-bd26-0a170fbfcbc9/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "6d5a97b2-788f-44e8-a3f2-dd36280377d9",
			"parent_table": "block",
			"file_ids": [
				"0b425e8a-75e0-4665-bd26-0a170fbfcbc9"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/37eb6d0f-b0c5-4895-a303-3e2277e4c623.png"
		},
		{
			"id": "f691f318-7c2d-4130-9956-43474dd4dfbd",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Очень заботимся о вашей безопасности\n\nОблако всего за 1 ₽"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "270370bf-fccd-4229-b97f-8c5a64bbb6e4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6d5a97b2-788f-44e8-a3f2-dd36280377d9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "28f27980-0894-4e28-a480-3fc7f1ff4531",
			"type": "column",
			"content": [
				"07770725-a21b-4196-ba4f-e856bf3db54f",
				"f7f3c302-c57f-4280-890e-e3bb2eeaf5db"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "6c8fef13-7b5a-4ddd-8e35-8398be2ef6f6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8eac0646-5474-4f48-8410-d689103fbdc4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "68791819-f23b-4c95-ad94-50c1f6022d24",
			"type": "column",
			"content": [
				"4cdb1f26-660c-40f8-89cc-12196df9805d",
				"fa61b984-a961-4eb6-91d6-65d4bfa9cffd"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "19369d05-807f-44c6-9577-a222b277a2c5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8eac0646-5474-4f48-8410-d689103fbdc4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "07770725-a21b-4196-ba4f-e856bf3db54f",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6e8f737e-f757-4bed-b066-cb8c1a99edde/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6e8f737e-f757-4bed-b066-cb8c1a99edde/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "28f27980-0894-4e28-a480-3fc7f1ff4531",
			"parent_table": "block",
			"file_ids": [
				"6e8f737e-f757-4bed-b066-cb8c1a99edde"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/07770725-a21b-4196-ba4f-e856bf3db54f.png"
		},
		{
			"id": "f7f3c302-c57f-4280-890e-e3bb2eeaf5db",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Календарь напомнит о встрече. Так будет легче не забыть \nо важном \n\nС заметками легче вести списки дел\n\nС Почтой вы сможете…"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "010d9797-744f-470e-a900-827255e42e05",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "28f27980-0894-4e28-a480-3fc7f1ff4531",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4cdb1f26-660c-40f8-89cc-12196df9805d",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/abe2ea0d-23eb-4257-b199-244416c99e51/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/abe2ea0d-23eb-4257-b199-244416c99e51/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "68791819-f23b-4c95-ad94-50c1f6022d24",
			"parent_table": "block",
			"file_ids": [
				"abe2ea0d-23eb-4257-b199-244416c99e51"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4cdb1f26-660c-40f8-89cc-12196df9805d.png"
		},
		{
			"id": "fa61b984-a961-4eb6-91d6-65d4bfa9cffd",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вы точно не пропустите встречу \n\n\n\nС заметками все задачи под контролем \n\nПочта всё сделает за вас"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "542842a0-118a-48bd-9947-e8d568ac2ea9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "68791819-f23b-4c95-ad94-50c1f6022d24",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "facf4830-8fd0-46c6-a82d-7c118659af41",
			"type": "column",
			"content": [
				"9ca0be54-69ad-4733-9194-59cd8a2befba",
				"d63bf4fd-0228-47bf-a2e1-4d4d515447e2"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "03cc8247-badc-4093-b1c0-ee2a1f9a4944",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b8bf1265-1fa2-4d0c-b082-53a6776edeb6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4b7ff809-e47a-4dcb-af98-0668a380fde1",
			"type": "column",
			"content": [
				"3952aaa4-7e41-43cf-8a15-8723fc969145",
				"86f6bae0-35c6-499b-8791-509c86817e0b"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "92c34daa-7178-4d29-a007-d069d6970b8a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b8bf1265-1fa2-4d0c-b082-53a6776edeb6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9ca0be54-69ad-4733-9194-59cd8a2befba",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/af7cf4eb-4529-448c-aa79-d00221d6aceb/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/af7cf4eb-4529-448c-aa79-d00221d6aceb/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "facf4830-8fd0-46c6-a82d-7c118659af41",
			"parent_table": "block",
			"file_ids": [
				"af7cf4eb-4529-448c-aa79-d00221d6aceb"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9ca0be54-69ad-4733-9194-59cd8a2befba.png"
		},
		{
			"id": "d63bf4fd-0228-47bf-a2e1-4d4d515447e2",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вы можете переместить все письма с заказами в отдельную папку — так легче за ними уследить"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "1334bbdf-08b1-45d3-a161-c87127177629",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "facf4830-8fd0-46c6-a82d-7c118659af41",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3952aaa4-7e41-43cf-8a15-8723fc969145",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/110acb5a-2fc3-4165-a0b2-12c4b32d69da/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/110acb5a-2fc3-4165-a0b2-12c4b32d69da/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "4b7ff809-e47a-4dcb-af98-0668a380fde1",
			"parent_table": "block",
			"file_ids": [
				"110acb5a-2fc3-4165-a0b2-12c4b32d69da"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3952aaa4-7e41-43cf-8a15-8723fc969145.png"
		},
		{
			"id": "86f6bae0-35c6-499b-8791-509c86817e0b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Кажется, вы стали получать много писем с заказами"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "35c2e685-8c3f-4bd6-9a8a-cd1b8103ec8d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4b7ff809-e47a-4dcb-af98-0668a380fde1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ecc22554-4640-43df-a586-013f3b522932",
			"type": "column",
			"content": [
				"bc93846c-8ff0-4afe-b953-a67bcae3113d",
				"8e0e2af6-93a1-4932-921f-755d3dab6f46"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "921e4bb8-b02b-4194-87cd-3ccfc2de8e22",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0f5bbefe-3e44-41cd-b271-a87640eb5c74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "47141466-7913-45e8-887e-788d58e834e5",
			"type": "column",
			"content": [
				"16ad880e-4977-402f-b0b2-44364ba773ca",
				"7db2b5af-6309-4f46-b165-6cf52b3cb68f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "5a27adb6-af91-4d54-a402-406ccf28b18d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0f5bbefe-3e44-41cd-b271-a87640eb5c74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bc93846c-8ff0-4afe-b953-a67bcae3113d",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b28d2d7a-bcd8-43b0-aa14-9218162e1d3d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b28d2d7a-bcd8-43b0-aa14-9218162e1d3d/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "ecc22554-4640-43df-a586-013f3b522932",
			"parent_table": "block",
			"file_ids": [
				"b28d2d7a-bcd8-43b0-aa14-9218162e1d3d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/bc93846c-8ff0-4afe-b953-a67bcae3113d.png"
		},
		{
			"id": "8e0e2af6-93a1-4932-921f-755d3dab6f46",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Артхаус или мелодрамы —составляйте подборки \nв Заметках, и еда не успеет остыть, пока вы ищите тот самый фильм"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9f976b37-3ae3-4bda-bce1-c2e0313d327a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ecc22554-4640-43df-a586-013f3b522932",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "16ad880e-4977-402f-b0b2-44364ba773ca",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1ab68887-675b-4df5-a9a3-71f597ebbd74/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1ab68887-675b-4df5-a9a3-71f597ebbd74/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "47141466-7913-45e8-887e-788d58e834e5",
			"parent_table": "block",
			"file_ids": [
				"1ab68887-675b-4df5-a9a3-71f597ebbd74"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/16ad880e-4977-402f-b0b2-44364ba773ca.png"
		},
		{
			"id": "7db2b5af-6309-4f46-b165-6cf52b3cb68f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Счастье — это смотреть кино всей семьёй. Сохраните любимые фильмы в Заметках"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "eafc9a53-1dc7-4011-bbd1-85307175b14f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "47141466-7913-45e8-887e-788d58e834e5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b8897ff1-6c2a-4d95-b742-f44f34eb65d6",
			"type": "column",
			"content": [
				"be7847d8-6983-472c-ac2e-1726d9693f5f",
				"8cd41934-cad5-4f2f-8ae3-e3e8029dfd60"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "6f6392df-2fc7-4ca3-a14b-efdd5b8b6cde",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b7a16b93-0fbc-48ba-8c2f-6f7aad5f614e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c578ec58-9927-4729-8d7b-34cc552b5ca6",
			"type": "column",
			"content": [
				"7c33d0f6-3ada-4d12-a907-2e0feff5c2f4",
				"8cd81ac0-6916-476f-b06e-e2ca68487356"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "1d5e16bd-1b39-4b4c-b3ef-0ca3ad73982a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b7a16b93-0fbc-48ba-8c2f-6f7aad5f614e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "be7847d8-6983-472c-ac2e-1726d9693f5f",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2334f5e5-2b96-4666-b5a1-d23d675edd6d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2334f5e5-2b96-4666-b5a1-d23d675edd6d/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "b8897ff1-6c2a-4d95-b742-f44f34eb65d6",
			"parent_table": "block",
			"file_ids": [
				"2334f5e5-2b96-4666-b5a1-d23d675edd6d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/be7847d8-6983-472c-ac2e-1726d9693f5f.png"
		},
		{
			"id": "8cd41934-cad5-4f2f-8ae3-e3e8029dfd60",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Фотографии загрузятся в ваше Облако. Ссылка на него придёт в письме "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "eccc40b3-bbd5-4514-a502-0f7d90d26917",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b8897ff1-6c2a-4d95-b742-f44f34eb65d6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c33d0f6-3ada-4d12-a907-2e0feff5c2f4",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f866de45-a123-4667-bd09-2cb7401fd7b4/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f866de45-a123-4667-bd09-2cb7401fd7b4/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c578ec58-9927-4729-8d7b-34cc552b5ca6",
			"parent_table": "block",
			"file_ids": [
				"f866de45-a123-4667-bd09-2cb7401fd7b4"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/7c33d0f6-3ada-4d12-a907-2e0feff5c2f4.png"
		},
		{
			"id": "8cd81ac0-6916-476f-b06e-e2ca68487356",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Фото загрузятся в хранилище. Ссылка на Облако будет отправлена в письме"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "da80bf12-ab73-4451-ab0a-038d6c5f94d6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c578ec58-9927-4729-8d7b-34cc552b5ca6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67212201-2bdb-4a09-ab0a-900f703e6a1a",
			"type": "column",
			"content": [
				"f205edf8-b87e-4151-aa33-a1fcf0d04912",
				"ce63d692-99f9-4f47-8529-5e01e2963230"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "781df653-cb0a-402c-a6b2-5fcb427eea6d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bf7ca23c-7587-49e1-8704-70f6669b6389",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "614e73cb-30b2-4bf9-bbd2-f493d5c8283a",
			"type": "column",
			"content": [
				"35d920e1-5277-48f0-8cb0-f1d2d99b6019",
				"1d6b6177-cf14-43be-b8a5-c8ec8257f523"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "b18b2518-0a67-49b1-be00-b34daf2b7a05",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bf7ca23c-7587-49e1-8704-70f6669b6389",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f205edf8-b87e-4151-aa33-a1fcf0d04912",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d816cc0b-3d5b-443f-b172-ae82d2bd0f2f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d816cc0b-3d5b-443f-b172-ae82d2bd0f2f/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "67212201-2bdb-4a09-ab0a-900f703e6a1a",
			"parent_table": "block",
			"file_ids": [
				"d816cc0b-3d5b-443f-b172-ae82d2bd0f2f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f205edf8-b87e-4151-aa33-a1fcf0d04912.png"
		},
		{
			"id": "ce63d692-99f9-4f47-8529-5e01e2963230",
			"type": "callout",
			"properties": {
				"title": [
					[
						"По вашему запросу ничего \nне найдено. Попробуйте изменить запрос \n\nХраните воспоминания \nбез границ — дарим \nскидку 30% на Облако"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a8109563-3cf6-4fd2-9825-0d0fa75c1d16",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "67212201-2bdb-4a09-ab0a-900f703e6a1a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "35d920e1-5277-48f0-8cb0-f1d2d99b6019",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/54b29309-1531-4ba6-8ee4-9425bd4d4ee0/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/54b29309-1531-4ba6-8ee4-9425bd4d4ee0/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "614e73cb-30b2-4bf9-bbd2-f493d5c8283a",
			"parent_table": "block",
			"file_ids": [
				"54b29309-1531-4ba6-8ee4-9425bd4d4ee0"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/35d920e1-5277-48f0-8cb0-f1d2d99b6019.png"
		},
		{
			"id": "1d6b6177-cf14-43be-b8a5-c8ec8257f523",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Нам жаль, но по запросу ничего не найдено\n\n\nМы вас любим! Вот вам скидка 30% на Облако "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ab78b693-1659-44d0-9e5a-c0973065755c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "614e73cb-30b2-4bf9-bbd2-f493d5c8283a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "88921780-b3c5-4348-b972-a2157488405c",
			"type": "column",
			"content": [
				"a5f1fffa-2621-4d41-96eb-bf6cf0300880",
				"36ada8b6-6aae-4cf5-8863-a41a5c9837cf"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "864f1787-1475-4e53-9d39-0a74e4ba5d86",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b8778fa0-dd31-4c67-9cca-4d0d6f7c66e6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6444cafc-114d-4930-86f0-9360e778fc8a",
			"type": "column",
			"content": [
				"38c71bfc-ecea-4ea2-bc55-2fdd4810c04c",
				"7e5ea491-e9a1-4da1-af28-7c1d5e2d39eb"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "f311c328-8af4-4897-a55f-3d1fc18c1b45",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b8778fa0-dd31-4c67-9cca-4d0d6f7c66e6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a5f1fffa-2621-4d41-96eb-bf6cf0300880",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/97f9e758-0d4d-4988-b75b-fb8546a3384c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/97f9e758-0d4d-4988-b75b-fb8546a3384c/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "88921780-b3c5-4348-b972-a2157488405c",
			"parent_table": "block",
			"file_ids": [
				"97f9e758-0d4d-4988-b75b-fb8546a3384c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/a5f1fffa-2621-4d41-96eb-bf6cf0300880.png"
		},
		{
			"id": "36ada8b6-6aae-4cf5-8863-a41a5c9837cf",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мы используем 50 моделей машинного обучения — это значит, что любой ваш вопрос будет решён за доли секунд\n\nИдеи подарков или \nактивностей — придумали шаблоны на все случаи жизни"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0e6939d9-1993-40d6-8d99-5ae1d4f1ed45",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "88921780-b3c5-4348-b972-a2157488405c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "38c71bfc-ecea-4ea2-bc55-2fdd4810c04c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9f75394e-c53c-46ce-93af-32af46ac872c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9f75394e-c53c-46ce-93af-32af46ac872c/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "6444cafc-114d-4930-86f0-9360e778fc8a",
			"parent_table": "block",
			"file_ids": [
				"9f75394e-c53c-46ce-93af-32af46ac872c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/38c71bfc-ecea-4ea2-bc55-2fdd4810c04c.png"
		},
		{
			"id": "7e5ea491-e9a1-4da1-af28-7c1d5e2d39eb",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мы используем 50 моделей машинного обучения \n\nУ нас 100 шаблонов заметок"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9abf0705-d893-4211-aee3-27850e990a39",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6444cafc-114d-4930-86f0-9360e778fc8a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e9e487b4-27ef-4bfb-9d80-db44605b0f08",
			"type": "column",
			"content": [
				"b7b3ce33-d1c2-4c2e-b144-9ebd0db8c4a2",
				"1d2de99f-0694-4975-ab7c-0e64546f5e65"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "628bccc6-a6b1-4e02-9293-597b2d1ee918",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a669ab06-e5b6-4d07-9694-71fee7bf219f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3a787547-210f-451c-b5d4-b7934b46d0e6",
			"type": "column",
			"content": [
				"8ce3682e-d952-45fc-8dd8-2dc217a32b44",
				"4ff811cc-cde1-4d65-99ef-c0d6b58b70b8"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "38efa53c-827b-479e-b602-5b74b48afab4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a669ab06-e5b6-4d07-9694-71fee7bf219f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7b3ce33-d1c2-4c2e-b144-9ebd0db8c4a2",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4facee8f-0152-4899-a382-397d481c99fc/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4facee8f-0152-4899-a382-397d481c99fc/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "e9e487b4-27ef-4bfb-9d80-db44605b0f08",
			"parent_table": "block",
			"file_ids": [
				"4facee8f-0152-4899-a382-397d481c99fc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b7b3ce33-d1c2-4c2e-b144-9ebd0db8c4a2.png"
		},
		{
			"id": "1d2de99f-0694-4975-ab7c-0e64546f5e65",
			"type": "callout",
			"properties": {
				"title": [
					[
						"На небе облачко в форме скидки на годовую подписку!"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5c937edc-9bb1-4af5-aa21-a002394d167b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e9e487b4-27ef-4bfb-9d80-db44605b0f08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8ce3682e-d952-45fc-8dd8-2dc217a32b44",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3b2d832a-efa5-420b-ab19-588942216d42/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3b2d832a-efa5-420b-ab19-588942216d42/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "3a787547-210f-451c-b5d4-b7934b46d0e6",
			"parent_table": "block",
			"file_ids": [
				"3b2d832a-efa5-420b-ab19-588942216d42"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/8ce3682e-d952-45fc-8dd8-2dc217a32b44.png"
		},
		{
			"id": "4ff811cc-cde1-4d65-99ef-c0d6b58b70b8",
			"type": "callout",
			"properties": {
				"title": [
					[
						"А у вас письма в Почте прошлогодние "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "1990d80e-0da8-4102-9c01-44d277592e1c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3a787547-210f-451c-b5d4-b7934b46d0e6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b4033ee-909f-4af2-9137-46426b2b197b",
			"type": "column",
			"content": [
				"78e5e78f-42a7-42cf-9d50-c7df95dab8ed",
				"caa39e1d-3d13-48b9-b8a8-67d9cb0ffe35"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "7d7bcec9-68f6-47ce-8f13-015d913715a5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd47ebe3-d051-4b2b-859f-61aff4b4414d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "36519d60-51a9-46e7-970e-370afc1922f5",
			"type": "column",
			"content": [
				"21a3fecb-943a-4bdf-a31c-c01de0aed74f",
				"b83c4555-6880-4177-9be8-36f3e3e4d2b6"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "5a3b6734-4ca7-4401-bc0f-644df9fd441d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd47ebe3-d051-4b2b-859f-61aff4b4414d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "78e5e78f-42a7-42cf-9d50-c7df95dab8ed",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c8eb8edc-80c7-4651-8085-29c10bc04e49/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c8eb8edc-80c7-4651-8085-29c10bc04e49/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "2b4033ee-909f-4af2-9137-46426b2b197b",
			"parent_table": "block",
			"file_ids": [
				"c8eb8edc-80c7-4651-8085-29c10bc04e49"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/78e5e78f-42a7-42cf-9d50-c7df95dab8ed.png"
		},
		{
			"id": "caa39e1d-3d13-48b9-b8a8-67d9cb0ffe35",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Рассказываем, как вы помогаете нам защитить вашу почту на все 100, и что мы делаем для этого сами "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0e43982e-572a-4e74-918f-4100f46aa7b7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2b4033ee-909f-4af2-9137-46426b2b197b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "21a3fecb-943a-4bdf-a31c-c01de0aed74f",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2d1a14fd-bb03-4753-8690-80778eb2ae91/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2d1a14fd-bb03-4753-8690-80778eb2ae91/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "36519d60-51a9-46e7-970e-370afc1922f5",
			"parent_table": "block",
			"file_ids": [
				"2d1a14fd-bb03-4753-8690-80778eb2ae91"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/21a3fecb-943a-4bdf-a31c-c01de0aed74f.png"
		},
		{
			"id": "b83c4555-6880-4177-9be8-36f3e3e4d2b6",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Рассказываем, чем мы лучше других почтовых сервисов\n\n "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8c5c805a-3835-4f8d-95be-82ba014600c2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "36519d60-51a9-46e7-970e-370afc1922f5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "21c26d22-f1ae-42ea-8ce9-61a314b2ab96",
			"type": "column",
			"content": [
				"02eccf98-41fb-4b12-98e6-21fbf580890c",
				"21e1d4ec-dc87-49f5-93a9-51ef9514aba0"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "2bd251c8-ac1d-46d1-a753-6f35b94d6ca9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2be11ce6-12a8-425f-8561-449969e0083d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0eeca7ec-4dd2-4daa-9087-3398d0bb4116",
			"type": "column",
			"content": [
				"d74ebcfc-72b6-4f27-812b-056e47cdd14b",
				"a188db32-1ee0-4843-a071-33f7a9a7ae85"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "fe59c1b0-a61d-486d-b12c-2ee5bbd72af8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2be11ce6-12a8-425f-8561-449969e0083d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "02eccf98-41fb-4b12-98e6-21fbf580890c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1808c3e0-f085-4656-9e79-f272bd579b56/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1808c3e0-f085-4656-9e79-f272bd579b56/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "21c26d22-f1ae-42ea-8ce9-61a314b2ab96",
			"parent_table": "block",
			"file_ids": [
				"1808c3e0-f085-4656-9e79-f272bd579b56"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/02eccf98-41fb-4b12-98e6-21fbf580890c.png"
		},
		{
			"id": "21e1d4ec-dc87-49f5-93a9-51ef9514aba0",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Принимаю правила пользовательского соглашения\n\nАвтор статьи — Аня К."
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "1ccc7aae-99f2-412f-b737-26db7aa3923b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "21c26d22-f1ae-42ea-8ce9-61a314b2ab96",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d74ebcfc-72b6-4f27-812b-056e47cdd14b",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f66572f7-2079-4e19-b45d-39f44ec5dcd1/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f66572f7-2079-4e19-b45d-39f44ec5dcd1/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "0eeca7ec-4dd2-4daa-9087-3398d0bb4116",
			"parent_table": "block",
			"file_ids": [
				"f66572f7-2079-4e19-b45d-39f44ec5dcd1"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d74ebcfc-72b6-4f27-812b-056e47cdd14b.png"
		},
		{
			"id": "a188db32-1ee0-4843-a071-33f7a9a7ae85",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Я согласен получать рассылку\n\nАвторка статьи в нашем блоге"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8abeee58-b269-47df-9dd9-b8229f2d7d45",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0eeca7ec-4dd2-4daa-9087-3398d0bb4116",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c5c14be9-ab52-4602-bbe3-3b5c83048abe",
			"type": "column",
			"content": [
				"2d1884e8-71f8-4844-86e2-bf0018b2ba5f",
				"458e4234-6fe3-462d-a985-2c751045961e"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "496391e2-9b8e-434d-965d-f4f067072f1e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "18fd90ca-6ab0-40db-98e9-51b0d9f56c2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "baf864ed-9a97-428a-bb83-47f05f285288",
			"type": "column",
			"content": [
				"ec16bc98-0cd6-4105-b132-67410031d9bd",
				"1d5ada11-36d2-438c-b04f-cf228111887b"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e48a035e-1f1a-45a4-8ab4-aba3d0254000",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "18fd90ca-6ab0-40db-98e9-51b0d9f56c2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2d1884e8-71f8-4844-86e2-bf0018b2ba5f",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5cbeef0c-0b9e-4f8c-8eaa-18523f4db895/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5cbeef0c-0b9e-4f8c-8eaa-18523f4db895/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c5c14be9-ab52-4602-bbe3-3b5c83048abe",
			"parent_table": "block",
			"file_ids": [
				"5cbeef0c-0b9e-4f8c-8eaa-18523f4db895"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2d1884e8-71f8-4844-86e2-bf0018b2ba5f.png"
		},
		{
			"id": "458e4234-6fe3-462d-a985-2c751045961e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Скидки на Облако до 70%\n\nПроверьте, сколько нужно памяти "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c1a91b78-06a2-4a01-a0ef-af94c905597d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c5c14be9-ab52-4602-bbe3-3b5c83048abe",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ec16bc98-0cd6-4105-b132-67410031d9bd",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e1435a2f-e49f-4d41-a531-25efe8596990/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e1435a2f-e49f-4d41-a531-25efe8596990/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "baf864ed-9a97-428a-bb83-47f05f285288",
			"parent_table": "block",
			"file_ids": [
				"e1435a2f-e49f-4d41-a531-25efe8596990"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ec16bc98-0cd6-4105-b132-67410031d9bd.png"
		},
		{
			"id": "1d5ada11-36d2-438c-b04f-cf228111887b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Скидки на Облако! Ура! \n\nСколько нужно памяти? Проверьте! "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "faee7e50-d758-4da2-b6d0-d1973b971801",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "baf864ed-9a97-428a-bb83-47f05f285288",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8ce6be93-2bb3-460b-8b3f-f8363256df49",
			"type": "column",
			"content": [
				"39b971c2-0bfe-4742-b3ba-63327d828965",
				"271296b4-5381-440f-ac3b-19eb4689a77d"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "df21db1b-a823-4669-bc85-f85f89699a53",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9672f76a-8d90-4ff8-88f6-8f6707fc9ed0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "db5e18c5-bbda-441b-8ccd-ed4353f1f908",
			"type": "column",
			"content": [
				"80872401-9615-46fb-8f0d-03c2300b2585",
				"ae0f5caa-7480-4fa0-b5e3-780ccd428d38"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "6e1b74af-0360-4cf7-b91c-68b60263894b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9672f76a-8d90-4ff8-88f6-8f6707fc9ed0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "39b971c2-0bfe-4742-b3ba-63327d828965",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/516cdba5-6aa8-444f-82b3-2179aef61fcd/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/516cdba5-6aa8-444f-82b3-2179aef61fcd/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "8ce6be93-2bb3-460b-8b3f-f8363256df49",
			"parent_table": "block",
			"file_ids": [
				"516cdba5-6aa8-444f-82b3-2179aef61fcd"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/39b971c2-0bfe-4742-b3ba-63327d828965.png"
		},
		{
			"id": "271296b4-5381-440f-ac3b-19eb4689a77d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Если вам нравится наше приложение, нажмите "
					],
					[
						"Да",
						[
							[
								"b"
							]
						]
					],
					[
						". Если не нравится, выберите "
					],
					[
						"Нет",
						[
							[
								"b"
							]
						]
					],
					[
						" \nи напишите, что бы вы хотели изменить"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f028e8aa-5746-4d1b-b434-e9e06b26d5ae",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8ce6be93-2bb3-460b-8b3f-f8363256df49",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "80872401-9615-46fb-8f0d-03c2300b2585",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/82bbef25-4a81-4a2f-b9d4-f4a273ae2029/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/82bbef25-4a81-4a2f-b9d4-f4a273ae2029/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "db5e18c5-bbda-441b-8ccd-ed4353f1f908",
			"parent_table": "block",
			"file_ids": [
				"82bbef25-4a81-4a2f-b9d4-f4a273ae2029"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/80872401-9615-46fb-8f0d-03c2300b2585.png"
		},
		{
			"id": "ae0f5caa-7480-4fa0-b5e3-780ccd428d38",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Нажми «Да» и поставь оценку \nв магазине приложений! Или “Нет”, и напиши, что улучшить "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "fc5748c1-85bc-470c-9a32-6f0e04fcfdc1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "db5e18c5-bbda-441b-8ccd-ed4353f1f908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Честность и простота",
			"id": "dd6edbae-0fe1-4b08-a5ab-9a9f710fc299"
		},
		{
			"title": "Взаимоуважение и равноправие ",
			"id": "1cdb7ad9-5192-4824-bcd4-17313d2f0dfb"
		}
	]
}} />
);

export default NotionVoiceAndToneCompetent;
